export const ADMIN_NOTIFICATION_PREF_KEY = 'adminNotificationEnabled';
export const ADMIN_NOTIFICATION_PREF_EVENT = 'adminNotificationPrefChanged';


